import Vue from "vue";
import Vuex from "vuex";
import User from "@/api/user";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    token: "",
    openId: "",
    info: {},
    isAnonymous: false,
    messageList: [],
    msgIdList: []
  },
  mutations: {
    // 切换匿名
    toggleAnonymous(state) {
      state.isAnonymous = !state.isAnonymous;
      User.updateChatInfo({ IsAnonymousSending: state.isAnonymous });
    },
    // 长按撤回
    withdrawMessage(state, msgId) {
      const index = state.messageList.findIndex(item => Number(item.msgId) === Number(msgId));
      state.messageList.splice(index, 1);
    },
    clearMessageList(state) {
      state.messageList = [];
      state.msgIdList = [];
    },
    // 添加消息到大厅
    addToMessageList(state, { message, list = [] }) {
      if (message) {
        list.push(message);
      }
      list.map(item => {
        const msgId = item.msgId;
        if (state.msgIdList.includes(msgId)) {
          return false;
        }
        // 以后优化,每次都会遍历现有的列表,而且一般最新的，时间戳最大都在最后面
        const index = state.messageList.findIndex(listItem => listItem.t >= item.t);
        if (index === -1) {
          state.messageList.push(item);
        } else {
          state.messageList.splice(index, 0, item);
        }
        state.msgIdList.push(item.msgId);
      });
    }
  },
  actions: {
    // 获取用户信息
    async getUserInfo({ state }, propInfo) {
      state.token = propInfo.Token;
      const data = await User.info();
      state.info = {
        userId: data.UserGuid,
        avatar: data.AvatarUrl,
        companyId: data.CompanyID,
        companyName: data.CompanyName,
        userName: data.UserName
      };
    }
  },
  modules: {}
});
